<template>
  <div class="cb-section cb-bar" :class="[{'cb-bar--left' : navIcon == 'left', 'cb-bar--right' : navIcon == 'right'}]" @click="navigate()" v-cb-link="'shadow'"
    :role="'navigation'" data-cb-id="estimate-fixed">
    <div class="cb-bar__wrap cb-bar__wrap--nohover">
      <div class="cb-bar__content">
        <div class="cb-bar__items">
          <div class="cb-bar__item" :style="themeColor">
            <div class="cb-bar__main"><span>{{t('cart.pay_now.label')}}</span></div>
            <div class="cb-bar__aside">{{ current_amount_due | cbCurrency(currency_code) }}</div>
          </div>
          <div class="cb-bar__item" v-if="firstNextEstimate">
            <div class="cb-bar__main"><span>{{t('cart.next_charge.label', {date: date(firstNextEstimate.date)})}}</span></div>
            <div class="cb-bar__aside">{{ nextInvTotal | cbCurrency(currency_code)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import CartHelper from "@/utils/cart-helper"
export default {
  props: ['editOrder', 'navIcon', 'fromCart'],
  computed: {
    ...mapGetters([
      'currency_code',
      'order_estimate_holder',
      'current_amount_due'
    ]),
    firstNextEstimate() {
      return this.order_estimate_holder.nextEstimates && this.order_estimate_holder.nextEstimates[0];
    },
    nextInvTotal() {
      return (this.firstNextEstimate && this.firstNextEstimate.total) || 0;
    }
  },
  methods: {
    navigate() {
      var section = this.fromCart ? "estimate_display_screen" : 
            (this.editOrder ? "estimate_display_screen" : "cart_new");
      var mode = this.editOrder ? "edit" : "";
      this.$router.customPush({
        name: section,
        query: {
          mode: mode
        }
      });
    },
  }

}
</script>



// WEBPACK FOOTER //
// EstimateFixed.vue?052da34b